<template>
 
       
        <drop v-show="$parent.$parent.editMode" ref="dropper" class="sectionDrop" @dragover="dragOver" @dragleave="dragOut" @dragend="dragOut" @drop="drop" >
            
        </drop>
       
 
</template>


<script>

export default{
    props: {level: Number, index: Number},
    methods: {
        dragOver: function(){
            if(this.par.dataTransfer.type == 'section')
                this.$refs.dropper.$el.classList.add('dropperDragOver')
        },
        dragOut: function(){
            this.$refs.dropper.$el.classList.remove('dropperDragOver')
        },
        drop: function(){
            this.$refs.dropper.$el.classList.remove('dropperDragOver')
            if(this.level == 1)
                this.par.drop(this.par.source.length)
            else 
                this.par.drop(this.index)

            this.par.dataTransfer = {}
        }
    },

    computed: {
        par: function(){
            if(this.level == 1)
                return this.$parent
            else 
                return this.$parent.$parent
        }
    }
}

</script>